import { SHARED } from "@securitize/domain";
import { InvestorInfo } from "../types/investorInformation.interface";

export const getInvestorTaxInfo = (
  investorInfo: InvestorInfo,
  considerOnly?: "US" | "nonUS",
) => {
  const [taxObject] = investorInfo.tax.filter((i) => {
    if (considerOnly === "US") {
      return i.taxCountryCode && SHARED.isUsTerritory(i.taxCountryCode);
    }
    if (considerOnly === "nonUS") {
      return i.taxCountryCode && !SHARED.isUsTerritory(i.taxCountryCode);
    }
    return true;
  });

  return {
    taxCountry: taxObject?.taxCountryCode ?? (considerOnly === "US" ? "US" : ""),
    taxPayerIdNumber: taxObject?.taxId ?? "",
    foreignTaxPayerId: taxObject?.taxId ?? "",
  };
};
